// extracted by mini-css-extract-plugin
export var deliveryRow = "_pq-a";
export var fixedHeight = "_pq-4";
export var freightLogo = "_pq-9";
export var fullWidth = "_pq-3";
export var priceColumn = "_pq-5";
export var radioSelected = "_pq-7";
export var radioUnselected = "_pq-6";
export var selectedOption = "_pq-2";
export var selectedOptionContainer = "_pq-1";
export var selection = "_pq-0";
export var tallSkeletonText = "_pq-8";